import { useLayoutEffect } from 'react';
import { useAppSelector } from 'hooks/redux';
import { getBodyClassName } from 'helpers/bodyClassName';

export function useBodyClassName(): void {
  const { location } = window;
  const collection = useAppSelector((state) => state.collection);

  useLayoutEffect(() => {
    if (!collection.type) return;

    const className = getBodyClassName({
      pathname: location.pathname,
      collection: {
        type: collection.type,
        templateName: collection.templateName,
        design: collection.design
      }
    });

    document.body.className = className;
  }, [
    location.pathname,
    collection.type,
    collection.templateName,
    collection.design?.disableDecorations
  ]);
}
